<template>
  <div class="login-link">
    <div v-if="!ui.showForm">
      <span><slot></slot></span> <span class="link underline" @click="ui.showForm = true">Hier Login-Link anfordern.</span>
    </div>
    <div v-else>
      <div class="input-wrapper">
        <input class="text-input" v-model="model.email" placeholder="Ihre E-Mail Adresse">
      </div>
      <div v-if="!ui.loading" class="btn link mt-20" :class="{'btn-disabled': $v.model.$invalid}" @click="send()"><span>Link anfordern</span></div>
      <spinner class="mt-20" v-else :size="'medium'"></spinner>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import { required, email } from 'vuelidate/lib/validators'
import Spinner from 'vue-simple-spinner'

export default {
  name: 'loginLink',
  components: {
    Spinner
  },
  data() {
    return {
      state: this.$store.state,
      ui: {
        showForm: false,
        loading: false,
        success: false
      },
      model: {
        email: ''
      }
    }
  },
  props: {
    open: Boolean
  },
  mounted() {
    if (this.open) {
      this.ui.showForm = true
    }
  },
  validations: {
    model: {
      email: {
        email, required
      }
    }
  },
  methods: {
    async send() {
      if (this.$v.model.$invalid) return false
      this.ui.loading = true
      await this.$sleep(300)
      let result
      try {
        let model = {}
        const token = await this.$recaptcha('login')
        model.recaptchaToken = token
        model.email = this.model.email
        result = await this.$http.post(this.state.app.apiUrl + 'login', model)
      } catch(err) {
        console.log(err)
        await this.$fire({
          title: 'Fehler!',
          text: err.response.data.message,
          type: "error"
        })
        this.ui.loading = false
        this.$emit('close')
        return
      }
      this.ui.loading = false
      this.ui.success = true
      this.ui.showForm = false
      await this.$fire({
        text: "Eine E-Mail mit einem Login-Link wurde an Sie verschickt. Bitte schauen Sie auch in ihren Spam-Ordner nach, falls Sie die Mail nicht gleich finden sollten.",
        type: "success",
        timer: 15000
      })
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" scoped>
.login-link {
  display:inline-block
  width:100%
}
.underline {
  text-decoration: underline
}
input {
  width 100%
  padding 1em 1.4em
  border-radius .35em
  border 0
  font-weight bold

  &::placeholder {
    color #807E6F
    font-weight bold
  }
}
.btn-disabled {
  opacity:0.7
}
.btn {
  background-color #BE1528
  padding 1.1em 3.2em
  text-align center
  border-radius 2em
  box-shadow 0 .3em 1em .3em rgba(0,0,0,0.5)

  span {
    font-size 1.14em
    color #ffffff
    font-weight bold
  }
}
</style>